module.exports = __webpack_public_path__ + "static/media/roman_soldier.6a0492e3.png";